<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value") {{ $i18n.t('common.common_gameName_memory') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_view') }}
            span(slot="value") {{ $i18n.t('trainer.trainer_gameFormSetting_' + parameters.viewType + 's')  }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_topics') }}
            span(slot="value" v-if="parameters.viewType === 'topic' || parameters.viewType === 'image'")
                |  {{ $i18n.t('trainer.trainer_gameFormSettingValue_' + parameters.selectedItems) }}
            span(slot="value" v-else v-for="group in parameters.selectedItems") {{ $i18n.t('trainer.trainer_gameFormSettingValue_' + group) }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
            span(slot="value") {{ parameters.difficult.amountOfRows + ' x ' + parameters.difficult.amountOfColumns }}
</template>

<script>
    /*eslint-disable*/
    import GamePreviewSettings from './GamePreviewSettings.vue';
    import GamePreviewSetting from './GamePreviewSetting.vue';
    import GamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [GamePreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        },
    }
</script>
